<section class="section-pad">
  <div class="container">

    <div class="flow-head">
      <p class="eyebrow">One submission. Maximum intelligent exposure.</p>
      <h2 class="section section--hero-line">How your plate <span class="em em--gold">finds its buyer.</span></h2>
      <p class="body" style="margin-top: 14px;">
        Dealer demand, search activity and discovery channels &mdash; running in parallel until the right offer comes back.
      </p>
    </div>

    <div class="flow">

      <div class="flow-row flow-row--top">

        <!-- 01 VALUE -->
        <div class="stage stage--light">
          <div class="stage-head">
            <span class="stage-num">01</span>
            <span class="stage-tag">Indicative</span>
          </div>
          <h3 class="stage-title">Value your plate</h3>
          <p class="stage-body">
            Real comparables, format scarcity, content readability and live demand signals &mdash; computed from the PlateX sold-data index in seconds.
          </p>
          <div class="val-preview">
            <div class="val-preview-row">
              <span class="plate md">{{ exampleValuationPlate }}</span>
              <div class="val-preview-range">
                <span class="val-preview-range-num">{{ exampleRange }}</span>
                <span class="val-preview-range-meta">indicative range</span>
              </div>
            </div>
            <div class="val-preview-meta">
              <span class="val-preview-meta-item"><span class="val-preview-dot" aria-hidden="true"></span>{{ exampleComparablesNote }}</span>
              <span class="val-preview-meta-item">{{ exampleFormatNote }}</span>
              <span class="val-preview-meta-item">{{ exampleLastComp }}</span>
            </div>
          </div>
          <p class="stage-meta">
            Built from the PlateX sold-data index &middot; 50 verified sales / 30d
          </p>
        </div>

        <!-- 02 DEMAND -->
        <div class="stage stage--rich">
          <div class="stage-head">
            <span class="stage-num">02</span>
            <span class="stage-tag">Routing logic</span>
          </div>
          <h3 class="stage-title">Routed to dealers</h3>
          <p class="stage-body">
            Your plate is matched to dealers in the PlateX network by format, content and stated buying interest &mdash; so it reaches the dealers most likely to act. Each dealer can place a cash bid, offer terms to list, or pass.
          </p>

          <div class="dealer-pane">
            <div class="dealer-pane-head">
              <span>Dealer view &middot; routing model</span>
              <span class="dealer-pane-live"><span class="pulse-dot sm" aria-hidden="true"></span>Example match</span>
            </div>
            <div class="dealer-pane-row">
              <span class="plate md">{{ exampleRegistration }}</span>
              <div class="dealer-pane-meta">
                <p class="dealer-pane-title">{{ exampleRegistration }}</p>
                <p class="dealer-pane-detail">Indicative {{ exampleDealerRange }} &middot; Reserve {{ exampleDealerReserve }}<br>{{ exampleDealerFilter }}</p>
              </div>
            </div>
            <div class="dealer-pane-actions">
              <span class="dealer-pane-btn dealer-pane-btn--a">Place cash bid</span>
              <span class="dealer-pane-btn dealer-pane-btn--b">Offer to list</span>
              <span class="dealer-pane-btn dealer-pane-btn--c">Pass</span>
            </div>
          </div>

          <p class="stage-meta">
            Dealers filter by format and content match so they only see what they buy &middot; no swamping
          </p>
        </div>

      </div>

      <!-- 03 BRANCH -->
      <div class="stage stage--branch">
        <div class="stage-head">
          <span class="stage-num">03</span>
          <span class="stage-tag stage-tag--branch">Two routes</span>
        </div>
        <h3 class="stage-title">Bids for stock. Or terms to list.</h3>
        <p class="stage-body" style="max-width: 720px;">
          Dealers respond two ways. They bid to buy plates they want for their own stock &mdash; usually liquid ones, dateless, strong content, names. For plates they'd rather list than own, they offer terms: a guaranteed minimum return, an asking price, and how their fees work. You see everything and decide.
        </p>

        <div class="branch-grid">
          <pla-plate-x-branch-card
            variant="charcoal"
            tag="3a &middot; Cash bid"
            when="If dealers want stock"
            title="Sell to a dealer"
            body="Dealers bid for plates they want for stock. You decide whether to accept."
            feedLabel="Example cash bids"
            [data]="cashBranch"></pla-plate-x-branch-card>

          <pla-plate-x-branch-card
            variant="green"
            tag="3b &middot; Open listing"
            when="If selling at retail"
            title="List with a dealer"
            body="Dealers offer terms with their fee structure shown. Compare actual returns side-by-side."
            feedLabel="Example listing terms"
            [data]="listingBranch"></pla-plate-x-branch-card>
        </div>
      </div>

      <!-- 04 SOLD -->
      <div class="stage stage--sold">
        <div class="stage-head">
          <span class="stage-num">04</span>
          <span class="stage-tag stage-tag--sold">Complete</span>
        </div>
        <div class="sold-grid">
          <div>
            <h3 class="stage-title">Sale completes</h3>
            <p class="stage-body">
              On a cash bid, the buying dealer completes the DVLA reassignment and pays you direct. On a listing, the dealer you chose runs the sale, finance and transfer &mdash; and pays you when it sells, against the guaranteed return you accepted.
            </p>
            <p class="stage-meta">
              You sign once and stop chasing. The dealer takes the wheel from there.
            </p>
          </div>
          <div class="sold-visual">
            <ng-container *ngIf="soldExample; else soldVisualFallback">
              <div class="sold-example">
                <span class="plate md">{{ soldExamplePlate }}</span>
                <div class="sold-example-meta">
                  <span class="sold-example-price">{{ soldExamplePrice }}</span>
                  <span class="sold-example-date" *ngIf="soldExampleDate">sold {{ soldExampleDate }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #soldVisualFallback>
              <img class="sold-image" [src]="soldVisualSrc" [alt]="soldVisualAlt" />
            </ng-template>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>
